// extracted by mini-css-extract-plugin
export var chevronIcon = "_d7-2";
export var teamName = "_d7-1";
export var teamSwitcherButton = "_d7-0";